import { CIDService } from "src/app/services/common/cid.service";
import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatPaginator,
  MatTableDataSource,
  MatDialog,
  MatSelectChange
} from "@angular/material";

import { ContractService } from "src/app/services/http/business/contract/contract.service";
import { SmsVarificationEntryComponent } from "../sms-varification-entry/sms-varification-entry.component";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ErrorsService } from "src/app/services/common/errors.service";
import { ICompany } from "src/app/interfaces/company";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { ContractDetailComponent } from "../contract-detail/contract-detail.component";

import { ContractEditComponent } from "../contract-entry/contract-edit/contract-edit.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ContractSearchComponent } from "../contract-search/contract-search.component";
import { HttpHeaders } from "@angular/common/http";
import { ContractExtensionComponent } from "../contract-extension/contract-extension.component";

@Component({
  selector: "app-contract-list",
  templateUrl: "./contract-list.component.html",
  styleUrls: ["./contract-list.component.css"]
})
export class ContractListComponent implements OnInit {
  now = new Date();
  displayedColumns: string[] = [
    this.translate.get("label.contractNumber"),
    this.translate.get("label.name"),
    // this.translate.get("label.lastname"),
    // this.translate.get("label.nationalCode"),
    this.translate.get("label.insurance"),
    //this.translate.get("label.insuranceDate"),
    this.translate.get("label.contractType"),
    this.translate.get("label.role"),
    this.translate.get("label.startDate"),
    this.translate.get("label.endDate"),
    'leavingJobDate',
    'function'
  ];
  dataSource = new MatTableDataSource();

  isOwner: boolean;
  companyCode: string;
  companyList: ICompany;
  //companySelected: string;
  CompanyEncryptId: string;
  filter: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private holdingSerice: HoldingService,
    private companyService: CompanyService,
    private snackBar: SnackBarService,
    private contractService: ContractService
  ) { }

  ngOnInit() {

    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.CompanyEncryptId ? this.CompanyEncryptId : this.cidService.getCID()
      );

    this.contractService.change.subscribe(() => {
      this.contractService.list(this.filter, 1, 10, headers).subscribe(re => {
        this.paginator.pageIndex = 0;
        this.dataSource = re.DataList;
        this.paginator.length = re.Total;
      });
    });

    //this.companySelected = this.cidService.getCID();
    this.checkOwner();
    if (!this.isOwner) {
      this.refresh();
    }
  }

  checkOwner() {
    this.holdingSerice.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }

  getInformation() {
    this.dialog
      .open(SmsVarificationEntryComponent, {
        maxWidth: "300px",
        data: this.companyCode
      })
      .afterClosed()
      .subscribe(() => {
        this.refresh();
      });
  }

  getParsDate(date: any): number {
    if (typeof (date) === 'string')
      return Date.parse(date);
    else if (date instanceof Date)
      return new Date(date).getTime()
  }

  edit(data: any) {
    console.log(data);

    this.dialog
      .open(ContractEditComponent, {
        width: "1200px",
        //maxHeight: "600px",
        data: data
      })
      .afterClosed()
      .subscribe(() => {
        this.refresh();
      });
  }


  search() {
    this.dialog
      .open(ContractSearchComponent, {
        width: '550px',
        data: null
      })
      .afterClosed()
      .subscribe(res => {

        this.filter = {};
        this.filter = res
        this.refresh();

      });
  }
  delete(data: any): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.contract") + " " + "'" + data.ContractNumber + "'"
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "350px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var deleted: any = {
        Id: data.Id
      };
      if (result) {
        this.contractService.delete(deleted).subscribe(
          () => {
            this.snackBar.OpenSnackBar(
              this.translate.get("success.deleteContract"),
              "ok",
              5000,
              SoundEnum.beep
            );
            this.refresh();
          },
          () => {
            this.errorService.transactionError();
          }
        );
      }
    });
  }

  refresh() {

    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.CompanyEncryptId ? this.CompanyEncryptId : this.cidService.getCID()
      );

    this.contractService.list(this.filter, 1, 10, headers).subscribe(res => {
      this.dataSource = new MatTableDataSource(res.DataList);
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
      //this.companySelected = this.cidService.getCID();
    });
  }

  loadContracts(e: MatSelectChange) {
    this.CompanyEncryptId = e.value
    if (this.isOwner)
      this.cidService.setCID(e.value)
    this.refresh();
  }

  paginatorEvent(event) {

    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.CompanyEncryptId ? this.CompanyEncryptId : this.cidService.getCID()
      );

    this.contractService
      .list(this.filter, event.pageIndex + 1, event.pageSize, headers)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(
      res => {
        this.companyList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  show(data: any) {
    console.log(data);

    this.dialog
      .open(ContractDetailComponent, {
        data: data,
        width: '450px'
      });
  }

  extension(data: any) {
    this.dialog
      .open(ContractExtensionComponent, {
        data: data,
        width: '550px'
      });
  }

  courseTypeList(e: MatSelectChange) {
    this.companyCode = e.value;

    this.refresh();
  }

  // ngOnDestroy() {

  // }
}
